import React from 'react'
import { Link } from 'react-router-dom';
import CloseIcon from './../../assets/images/icon/close.png';
const PrivacyPolicy = () => {
    return (
        <section className="privacy-policy">
            <Link to="/#contact" className="mt-0" style={{ background: '#f7f8fc' }}>
                <img className="close-img" src={CloseIcon} alt="Close" />
            </Link>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="page-header">
                            <h1>Privacy Policy</h1>
                            <p align="justify">At Vision Workspaces, we are committed to protecting your privacy and handling your personal information with transparency and integrity. This Privacy Policy outlines how we collect, use, store, and protect the data you provide when you visit our website or use our workspace services.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="privacy-policy-content">
                            <div className="privacy-policy-item">
                                <h2>1. Information We Collect</h2>
                                <p align="justify">We may collect the following types of personal and business-related information:
                                </p>
                                <ul>
                                    <li>Name, email address, phone number</li>
                                    <li>Company name and position/title</li>
                                    <li>Billing and payment information</li>
                                    <li>Service inquiries and preferences</li>
                                    <li>Booking history and usage data</li>
                                    <li>IP address and browser/device information (via cookies)</li>
                                </ul>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>2. How We Use Your Information</h2>
                                <p align="justify">Your information may be used for the following purposes:</p>
                                <ul>
                                    <li>To process inquiries and service bookings</li>
                                    <li>To send booking confirmations and service updates</li>
                                    <li>To provide customer support</li>
                                    <li>To improve our website and services</li>
                                    <li>To send promotional materials (with your consent)</li>
                                    <li>To comply with legal or regulatory obligations</li>
                                </ul>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>3. Sharing of Information</h2>
                                <p align="justify">We do not sell or rent your personal information. We may share your information with:</p>
                                <ul>
                                    <li>Trusted third-party service providers (e.g., payment gateways, IT support)</li>
                                    <li>Legal authorities when required by law</li>
                                    <li>Internal team members on a need-to-know basis</li>
                                </ul>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>4. Data Security</h2>
                                <p align="justify">
                                    We use industry-standard security measures to protect your data, including:
                                </p>
                                <ul>
                                    <li>Secure servers and encrypted connections</li>
                                    <li>Restricted access to personal data</li>
                                    <li>Regular updates to our systems and software</li>
                                </ul>
                                <p align="justify">
                                    However, no online transmission or storage system is 100% secure. We cannot guarantee absolute data security but we take all reasonable precautions.
                                </p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>5. Cookies and Tracking Technologies</h2>
                                <p align="justify">
                                    We use cookies and analytics tools to:
                                </p>
                                <ul>
                                    <li>Understand user behavior and improve user experience</li>
                                    <li>Remember your preferences and login details</li>
                                    <li>Track visits and website traffic sources</li>
                                </ul>
                                <p align="justify">You can manage or disable cookies through your browser settings.</p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>6. Your Rights</h2>
                                <p align="justify">
                                    Depending on your location, you may have the right to:
                                </p>
                                <ul>
                                    <li>Access the personal information we hold about you</li>
                                    <li>Request corrections or updates</li>
                                    <li>Request deletion of your data</li>
                                    <li>Withdraw consent for marketing emails at any time</li>
                                    <li>File a complaint with a data protection authority</li>
                                </ul>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>7. Third-Party Links</h2>
                                <p align="justify">
                                    Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those websites. We encourage you to review their privacy policies.
                                </p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>8. Changes to This Policy</h2>
                                <p align="justify">
                                    We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date. Continued use of our website and services implies acceptance of the revised policy.
                                </p>
                            </div>
                            <div className="privacy-policy-item">
                                <h2>9. Contact Us</h2>
                                <p align="justify">
                                    If you have any questions or concerns about this Privacy Policy or how your data is handled, please contact us:
                                </p>
                                <ul>
                                    <li>📧 <strong>Email: </strong>contact@visionworkspaces.com</li>
                                    <li>📞 <strong>Phone: </strong>+91 90826 67792</li>
                                    <li>🏢 <strong>Address: </strong>Karmayogi Corporate Park, Orange Street, Plot No 7,<br />
                                        Bhau Saheb Survey Nagar, Trimurtee Nagar, Nagpur, 440022</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PrivacyPolicy
